import { render, staticRenderFns } from "./ExtrusionDetail.vue?vue&type=template&id=fbb80432"
import script from "./ExtrusionDetail.vue?vue&type=script&lang=js"
export * from "./ExtrusionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports